// export const Api = "https://ahmedgalal75.bsite.net/api/";

export const Api = "https://www.ets005.somee.com/api/";
// export const Api = "https://rydhqexamapp01/api/";
